import {Component, h} from "@stencil/core";

@Component({
    tag: 'legal-component',
    shadow: false
})
export class LegalComponent {
    public static readonly TAG_NAME = "legal-component";

    componentDidLoad() {
        document.querySelectorAll('.additionalLegalCopy').forEach(function(elem) {
            let legalParagraph = document.createElement('p');
            legalParagraph.innerHTML = elem.innerHTML;
            if (document.getElementById('secondary_legal'))
                document.getElementById('secondary_legal').appendChild(legalParagraph);
        });
    }

    render() {
        return [
            <p2 id={'secondary_legal'}> </p2>
        ]
    }
}
